import React from 'react';
import { IResponse } from '../gql/get-user';

export const LoggedInUserContext = React.createContext<IResponse | null>(null);
export const LoggedInUserProvider = LoggedInUserContext.Provider;
